export default function ({plex, plugCount}) {
  switch (plex) {
    case 'dx':
      return plugCount * 2
    default:
      return plugCount
  }
}